<template lang="pug">
#app
  px-header
  router-view
  px-footer
</template>

<script>
// @ is an alias to /src
import PxHeader from "@/components/PxHeader";
import PxFooter from "@/components/PxFooter";
import airportsData from "!raw-loader!@/assets/airports.dat";

//import { mapState, mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    PxHeader,
    PxFooter,
  },
  mounted() {
    const airportsArray = airportsData.split(/\r?\n/);
    const dataDescription = [
      "airportId",
      "name",
      "city",
      "country",
      "IATA",
      "ICAO",
      "latitude",
      "longitude",
      "altitude",
      "timezone",
      "DST",
      "tzDatabaseTimeZone",
      "type",
      "source",
    ];
    const airports = airportsArray.map((dataString) => {
      const airportArray = dataString.split(",").map((dataElement, index) => {
        const res = {};
        res[dataDescription[index]] = dataElement
          .replace('"', "")
          .replace('"', "");
        return res;
      });

      let airportObject = {};
      for (let airport of airportArray) {
        airportObject = { ...airportObject, ...airport };
      }
      return airportObject;
    });

    this.$store.dispatch("setAirports", airports);

    if (this.$cookies.get("token")) {
      this.$store.dispatch("setUser", {
        vm: this,
        token: this.$cookies.get("token"),
        id: this.$cookies.get("id"),
        firstName: this.$cookies.get("firstName"),
        lastName: this.$cookies.get("lastName"),
        email: this.$cookies.get("email"),
        userName: this.$cookies.get("userName"),
        role: this.$cookies.get("role"),
      });
    }

    //const found = airports.find((airport) => airport.IATA === "AQP");
    //console.log("found", found);
  },
  /*data() {
    return {
      token: this.$cookies.get("token"),
    };
  },
  methods: {},*/
};
</script>

<style>
:root {
  --azul: #005;
}

h1,
h2,
h3 {
  margin-top: 1em;
  margin-bottom: 0.5em;
}

h1,
h2 {
  font-weight: bold;
  letter-spacing: -0.02em;
}

h3 {
  /*list-style: decimal;
  display: list-item;
  list-style-position: inside;*/
  position: relative;
  padding-left: 1.5em;
}

h3:before {
  content: "";
  display: block;
  background-color: var(--secondary);
  color: white;
  width: 1.25em;
  height: 1.25em;
  position: absolute;
  left: 0;
  top: -0.08em;
  border-radius: 50%;
  counter-increment: titles;
  content: counter(titles);
  text-align: center;
  line-height: 1.325em;
}

h3::marker {
  color: white;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

#page {
  overflow: hidden;
}

#page > .row > * {
  counter-reset: titles;
}
</style>
